import greaterOrEqualTo from '../../validators/greaterOrEqualTo'

export default {
  name: 'EventListFilterPartialView',

  props: {
    regions: {
      type: Array,
      required: true
    },
    statuses: {
      type: Array,
      required: true
    },
    types: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      beingReset: false,
      filter: {
        eventCode: '',
        startDateFrom: '',
        startDateTo: '',
        endDateFrom: '',
        endDateTo: '',
        regionId: '',
        status: '',
        types: ''
      }
    }
  },

  computed: {
    regionOptions () {
      let options = [
        {
          text: '-- Any --',
          value: ''
        }
      ]
      for (let i = 0; i < this.regions.length; i++) {
        let region = this.regions[i]
        options.push({
          text: region.name,
          value: region.storeRegionID
        })
      }

      return options
    }
  },

  validations: {
    filter: {
      startDateTo: {
        greater: greaterOrEqualTo('startDateFrom')
      },
      endDateTo: {
        greater: greaterOrEqualTo('endDateFrom')
      }
    }
  },

  methods: {
    applyFilter () {
      this.$v.$touch()
      this.$store.commit('setFilter', this.filter)
      this.$emit('apply')
    },

    resetFilter () {
      this.beingReset = true
      this.filter = {
        eventCode: '',
        startDateFrom: '',
        startDateTo: '',
        endDateFrom: '',
        endDateTo: '',
        regionId: '',
        status: '',
        types: ''
      }

      // hack to rerender flatpickr
      setTimeout(() => {
        this.beingReset = false
      }, 0)

      this.applyFilter()
    }
  },

  created () {
    this.filter = this.$store.state.filter
  }
}



// WEBPACK FOOTER //
// ./src/views/EventList/EventListFilter.js